import { ISnippet } from "./snippet";
import { createSnippet } from "./snippet";

export interface IReport {
  id: number;
  date: string;
  headline: string;
  source: IReportSource;
  snippets: ISnippet[];
  textBody: string;
  url: string;
  topimage: string;
}

export interface IReports {
  reports: IReport[];
  hasMorePages: boolean;
}

export interface IReportBackend {
  id: number;
  date_published: string;
  headline: string;
  snippets: string[];
  source: IReportSourceBackend;
  maintext: string;
  url: string;
  topimage: string;
  meta: IMeta;
  location: ILocation;
}

export interface IParams {
  enddate: string;
  keywords: string;
  page: number;
  pagesize: number;
  regions: string;
  startdate: string;
  categories?: string;
}

export interface ILocation {
  country: string;
  region: string;
  geo_level: string;
}

export interface IMeta {
  date_downloaded: string;
  iframe_accessible: boolean | null;
  language: string;
  obtained_from: string;
}

export interface ILocation {
  country: string;
  region: string;
  geo_level: string;
}

export interface IMeta {
  date_downloaded: string;
  iframe_accessible: boolean | null;
  language: string;
  obtained_from: string;
}

export interface IReportSourceBackend {
  id: number | null;
  category: string;
  logo: string;
  name: string;
  domain: string;
}

export interface IReportSource {
  id: number | null;
  category: string;
  iframeAccessible: boolean | null;
  logo: string;
  name: string;
  country: string;
  region: string;
  geoLevel: string;
  domain: string;
  language: string;
}

export const createReportSource = (
  source: IReportSourceBackend,
  meta: IMeta,
  location: ILocation
): IReportSource => {
  return Object.freeze({
    id: source.id,
    category: source.category,
    iframeAccessible: meta.iframe_accessible,
    logo: source.logo,
    name: source.name,
    country: location.country,
    geoLevel: location.geo_level,
    region: location.region,
    domain: source.domain,
    language: meta.language,
  });
};

export const createReport = (report: IReportBackend): IReport => {
  return Object.freeze({
    id: report.id,
    date: report.date_published,
    headline: report.headline,
    source: createReportSource(report.source, report.meta, report.location),
    snippets: report.snippets.map((snippet: string) =>
      createSnippet({
        id: null,
        source: report.source.name,
        report_name: report.source.name,
        report_url: report.url,
        text: snippet,
      })
    ),
    textBody: report.maintext,
    url: report.url,
    topimage: report.topimage,
  });
};

export const createReports = (reports: {
  reports: IReportBackend[];
  has_more_pages: boolean;
}): IReports => {
  return Object.freeze({
    reports: reports.reports.map((report: IReportBackend) =>
      createReport(report)
    ),
    hasMorePages: reports.has_more_pages,
  });
};

// export interface ISnippetBackend {
//   id: number | null;
//   report_name: string;
//   report_url: string;
//   source: string | ISnippetSourceBackend;
//   text: string;
// }
